module.exports = {
  sessionSecret: 'e9212f5140a11d997ada5ccfe91b143483ca2042c31ccdd7d826f937b4214223',
  neo4j: {
    login: 'neo4j',
    password: '323d22ebaf1fb1b6d7b71cdb6ce2322ee4cb8fe3804758d8534da69461f3fbb9'
  }
}
